import { createContent, ordinalIndicator } from '@altify/utils';
import { getWeekdayName } from './helpers/weekdays';
import { RecurringBuySchedule } from './models/RecurringBuySchedule';

export const recurringBuySharedContent = createContent({
  en: {
    today: 'Today',
    setSchedule: 'Set your schedule',
    recurringSchedule: (schedule: RecurringBuySchedule) => {
      const buyToday = schedule.buyNow ? 'Today, then ' : '';
      return schedule.interval === 'weekly'
        ? `${buyToday}Weekly on a ${getWeekdayName(schedule.dayOfWeek, 'en')}`
        : `${buyToday} Monthly on the ${schedule.dayOfMonth}${ordinalIndicator(
          schedule.dayOfMonth,
        )}`;
    },
  },
  de: {
    today: 'Heute',
    setSchedule: 'Lege deinen Zeitplan fest',
    recurringSchedule: (schedule: RecurringBuySchedule) => {
      const buyToday = schedule.buyNow ? 'Heute, dann' : '';
      return schedule.interval === 'weekly'
        ? `${buyToday} Wöchentlich an einem ${getWeekdayName(schedule.dayOfWeek, 'de')}`
        : `${buyToday} Monatlich am ${schedule.dayOfMonth}.`;
    },
  },
});
